/* eslint-disable react-hooks/exhaustive-deps */

import React, { useCallback, useMemo, useState } from 'react';
import { getTaxSingoDataType } from '../../../../utils/taxPortal/tax-singo';
import { putTaxSingoTaxPayerSingo } from '../../../../apis/tax-portal/tax-singo/tax-singo';
import { viewLoading } from '../../../../utils/loading';

import { classnames } from "../../../../utils/text";
import Button from '../../../Button';

// props = { scheduled, taxpayerSingo, dataIdx, reSubmit }
const TaxSingoItem = (props) => {
  const {
    // scheduled,
    taxpayerSingo,
    dataIdx,
    reSubmit
  } = props

  const data = useMemo(() => {
    return taxpayerSingo?.data?.find((d) => d.idx === dataIdx) || null
  }, [taxpayerSingo, dataIdx])

  const dataType = useMemo(() => {
    return getTaxSingoDataType(data?.dataType)
  }, [data])


  const [isMemoMode, setIsMemoMode] = useState(false)

  const onChange = useCallback((updatedData) => {
    const updatedTaxpayerSingo = {
      ...taxpayerSingo,
      data: taxpayerSingo.data.map((item) =>
        item.idx === dataIdx ? updatedData : item
      ),
    }
    viewLoading(true);

    putTaxSingoTaxPayerSingo(
      taxpayerSingo.idx,
      updatedTaxpayerSingo
    )
      .then((res) => {
        console.log(res);
        reSubmit();
      })
      .finally(() => {
        viewLoading(false);
      });
  }, [dataIdx, reSubmit, taxpayerSingo])


  const [dataMemo, setDataMemo] = useState("");
  const handleOnTextAreaChange = (e) => {
    setDataMemo(e.target.value);
  };

  const openDataMemo = (isOpen) => {
    if (isOpen) {
      setDataMemo(data?.memo || '')
    }
    setIsMemoMode(isOpen)
  }

  const saveMemo = useCallback(() => {
    const updatedData = {
      ...data,
      memo: dataMemo
    }
    onChange(updatedData)
    openDataMemo(false)
  }, [data, dataMemo, onChange])

  return <>
    {
      data ?
        <div className={classnames("tax-singo-item-wrap", {
          "tax-singo-item-memo-open": isMemoMode
        })}>
          {
            dataType ? <dataType.Component
              {...props}
              openDataMemo={openDataMemo}
              onChange={onChange}
              data={data}
            /> : data?.value || ''
          }
          {data.memo && <i className='bx bx-notepad' />}
          {
            isMemoMode &&
            <div className='tax-singo-item-drop-box tax-singo-item-memo-box'>
              <div className='tax-sing-item-drop-box-header'>
                {data.name}
              </div>
              <div className='tax-sing-item-drop-box-contents'>
                <textarea
                  name="tax-singo-item-memo"
                  className="tax-singo-item-memo"
                  placeholder="메모 입력"
                  value={dataMemo}
                  onChange={handleOnTextAreaChange}
                />
              </div>
              <div className='tax-singo-item-bottom'>
                <Button
                  label={'취소'}
                  size="tiny"
                  color="danger"
                  onClick={() => openDataMemo(false)}
                />

                <Button
                  label={'저장'}
                  size="tiny"
                  onClick={() => saveMemo()}
                />
              </div>
            </div>
          }
        </div>
        :
        '-'}
  </>
}

export default TaxSingoItem